import React from 'react';
import { Breadcrumbs } from '@gafe/common-ui';
import merge from 'classnames';

import { ProgressSpinner } from '@/components/generic/ProgressSpinner';

import { Props } from './types';

import styles from './PageContentContainerV2.module.scss';

export const PageContentContainer = (props: Props) => {
  const {
    footer,
    actions,
    children,
    className,
    classes = {},
    breadcrumbs = [],
    isLoading = false,
    type = 'container',
  } = props;

  if (isLoading) {
    return <ProgressSpinner />;
  }

  return (
    <div
      className={merge(
        {
          [styles.wrapper]: type !== 'md_wrapper',
          [styles.md_wrapper]: type === 'md_wrapper',
          [styles.simple_container]: type === 'simple_container',
        },
        classes.wrapper,
      )}
      data-testid="page-content-wrapper"
    >
      <div className={styles.header}>
        <div>
          <Breadcrumbs items={breadcrumbs} />
        </div>

        {actions}
      </div>

      <div className={merge(className, { [styles.container]: type !== 'wrapper' })}>{children}</div>

      {footer && <div className={styles.footer}>{footer}</div>}
    </div>
  );
};
